export const momentLocaleLoaders: Record<string, () => Promise<void>> = {
  'af': () => import('../../../../node_modules/moment/locale/af.js'),
  'ar': () => import('../../../../node_modules/moment/locale/ar.js'),
  'ar-dz': () => import('../../../../node_modules/moment/locale/ar-dz.js'),
  'ar-kw': () => import('../../../../node_modules/moment/locale/ar-kw.js'),
  'ar-ly': () => import('../../../../node_modules/moment/locale/ar-ly.js'),
  'ar-ma': () => import('../../../../node_modules/moment/locale/ar-ma.js'),
  'ar-ps': () => import('../../../../node_modules/moment/locale/ar-ps.js'),
  'ar-sa': () => import('../../../../node_modules/moment/locale/ar-sa.js'),
  'ar-tn': () => import('../../../../node_modules/moment/locale/ar-tn.js'),
  'az': () => import('../../../../node_modules/moment/locale/az.js'),
  'be': () => import('../../../../node_modules/moment/locale/be.js'),
  'bg': () => import('../../../../node_modules/moment/locale/bg.js'),
  'bm': () => import('../../../../node_modules/moment/locale/bm.js'),
  'bn': () => import('../../../../node_modules/moment/locale/bn.js'),
  'bn-bd': () => import('../../../../node_modules/moment/locale/bn-bd.js'),
  'bo': () => import('../../../../node_modules/moment/locale/bo.js'),
  'br': () => import('../../../../node_modules/moment/locale/br.js'),
  'bs': () => import('../../../../node_modules/moment/locale/bs.js'),
  'ca': () => import('../../../../node_modules/moment/locale/ca.js'),
  'cs': () => import('../../../../node_modules/moment/locale/cs.js'),
  'cv': () => import('../../../../node_modules/moment/locale/cv.js'),
  'cy': () => import('../../../../node_modules/moment/locale/cy.js'),
  'da': () => import('../../../../node_modules/moment/locale/da.js'),
  'de': () => import('../../../../node_modules/moment/locale/de.js'),
  'de-at': () => import('../../../../node_modules/moment/locale/de-at.js'),
  'de-ch': () => import('../../../../node_modules/moment/locale/de-ch.js'),
  'dv': () => import('../../../../node_modules/moment/locale/dv.js'),
  'el': () => import('../../../../node_modules/moment/locale/el.js'),
  'en-au': () => import('../../../../node_modules/moment/locale/en-au.js'),
  'en-ca': () => import('../../../../node_modules/moment/locale/en-ca.js'),
  'en-gb': () => import('../../../../node_modules/moment/locale/en-gb.js'),
  'en-ie': () => import('../../../../node_modules/moment/locale/en-ie.js'),
  'en-il': () => import('../../../../node_modules/moment/locale/en-il.js'),
  'en-in': () => import('../../../../node_modules/moment/locale/en-in.js'),
  'en-nz': () => import('../../../../node_modules/moment/locale/en-nz.js'),
  'en-sg': () => import('../../../../node_modules/moment/locale/en-sg.js'),
  'eo': () => import('../../../../node_modules/moment/locale/eo.js'),
  'es': () => import('../../../../node_modules/moment/locale/es.js'),
  'es-do': () => import('../../../../node_modules/moment/locale/es-do.js'),
  'es-mx': () => import('../../../../node_modules/moment/locale/es-mx.js'),
  'es-us': () => import('../../../../node_modules/moment/locale/es-us.js'),
  'et': () => import('../../../../node_modules/moment/locale/et.js'),
  'eu': () => import('../../../../node_modules/moment/locale/eu.js'),
  'fa': () => import('../../../../node_modules/moment/locale/fa.js'),
  'fi': () => import('../../../../node_modules/moment/locale/fi.js'),
  'fil': () => import('../../../../node_modules/moment/locale/fil.js'),
  'fo': () => import('../../../../node_modules/moment/locale/fo.js'),
  'fr': () => import('../../../../node_modules/moment/locale/fr.js'),
  'fr-ca': () => import('../../../../node_modules/moment/locale/fr-ca.js'),
  'fr-ch': () => import('../../../../node_modules/moment/locale/fr-ch.js'),
  'fy': () => import('../../../../node_modules/moment/locale/fy.js'),
  'ga': () => import('../../../../node_modules/moment/locale/ga.js'),
  'gd': () => import('../../../../node_modules/moment/locale/gd.js'),
  'gl': () => import('../../../../node_modules/moment/locale/gl.js'),
  'gom': () => import('../../../../node_modules/moment/locale/gom-deva.js'), // fallback to gom-deva for gom language
  'gom-deva': () => import('../../../../node_modules/moment/locale/gom-deva.js'),
  'gom-latn': () => import('../../../../node_modules/moment/locale/gom-latn.js'),
  'gu': () => import('../../../../node_modules/moment/locale/gu.js'),
  'he': () => import('../../../../node_modules/moment/locale/he.js'),
  'hi': () => import('../../../../node_modules/moment/locale/hi.js'),
  'hr': () => import('../../../../node_modules/moment/locale/hr.js'),
  'hu': () => import('../../../../node_modules/moment/locale/hu.js'),
  'hy-am': () => import('../../../../node_modules/moment/locale/hy-am.js'),
  'id': () => import('../../../../node_modules/moment/locale/id.js'),
  'is': () => import('../../../../node_modules/moment/locale/is.js'),
  'it': () => import('../../../../node_modules/moment/locale/it.js'),
  'it-ch': () => import('../../../../node_modules/moment/locale/it-ch.js'),
  'ja': () => import('../../../../node_modules/moment/locale/ja.js'),
  'jv': () => import('../../../../node_modules/moment/locale/jv.js'),
  'ka': () => import('../../../../node_modules/moment/locale/ka.js'),
  'kk': () => import('../../../../node_modules/moment/locale/kk.js'),
  'km': () => import('../../../../node_modules/moment/locale/km.js'),
  'kn': () => import('../../../../node_modules/moment/locale/kn.js'),
  'ko': () => import('../../../../node_modules/moment/locale/ko.js'),
  'ku': () => import('../../../../node_modules/moment/locale/ku.js'),
  'ku-kmr': () => import('../../../../node_modules/moment/locale/ku-kmr.js'),
  'ky': () => import('../../../../node_modules/moment/locale/ky.js'),
  'lb': () => import('../../../../node_modules/moment/locale/lb.js'),
  'lo': () => import('../../../../node_modules/moment/locale/lo.js'),
  'lt': () => import('../../../../node_modules/moment/locale/lt.js'),
  'lv': () => import('../../../../node_modules/moment/locale/lv.js'),
  'me': () => import('../../../../node_modules/moment/locale/me.js'),
  'mi': () => import('../../../../node_modules/moment/locale/mi.js'),
  'mk': () => import('../../../../node_modules/moment/locale/mk.js'),
  'ml': () => import('../../../../node_modules/moment/locale/ml.js'),
  'mn': () => import('../../../../node_modules/moment/locale/mn.js'),
  'mr': () => import('../../../../node_modules/moment/locale/mr.js'),
  'ms': () => import('../../../../node_modules/moment/locale/ms.js'),
  'ms-my': () => import('../../../../node_modules/moment/locale/ms-my.js'),
  'mt': () => import('../../../../node_modules/moment/locale/mt.js'),
  'my': () => import('../../../../node_modules/moment/locale/my.js'),
  'nb': () => import('../../../../node_modules/moment/locale/nb.js'),
  'ne': () => import('../../../../node_modules/moment/locale/ne.js'),
  'nl': () => import('../../../../node_modules/moment/locale/nl.js'),
  'nl-be': () => import('../../../../node_modules/moment/locale/nl-be.js'),
  'nn': () => import('../../../../node_modules/moment/locale/nn.js'),
  'oc': () => import('../../../../node_modules/moment/locale/oc-lnc.js'), // fallback to oc-lnc for oc language
  'oc-lnc': () => import('../../../../node_modules/moment/locale/oc-lnc.js'),
  'pa': () => import('../../../../node_modules/moment/locale/pa-in.js'), // fallback to pa-IN for pa language
  'pa-in': () => import('../../../../node_modules/moment/locale/pa-in.js'),
  'pl': () => import('../../../../node_modules/moment/locale/pl.js'),
  'pt': () => import('../../../../node_modules/moment/locale/pt.js'),
  'pt-br': () => import('../../../../node_modules/moment/locale/pt-br.js'),
  'ro': () => import('../../../../node_modules/moment/locale/ro.js'),
  'ru': () => import('../../../../node_modules/moment/locale/ru.js'),
  'sd': () => import('../../../../node_modules/moment/locale/sd.js'),
  'se': () => import('../../../../node_modules/moment/locale/se.js'),
  'si': () => import('../../../../node_modules/moment/locale/si.js'),
  'sk': () => import('../../../../node_modules/moment/locale/sk.js'),
  'sl': () => import('../../../../node_modules/moment/locale/sl.js'),
  'sq': () => import('../../../../node_modules/moment/locale/sq.js'),
  'sr': () => import('../../../../node_modules/moment/locale/sr.js'),
  'sr-cyrl': () => import('../../../../node_modules/moment/locale/sr-cyrl.js'),
  'ss': () => import('../../../../node_modules/moment/locale/ss.js'),
  'sv': () => import('../../../../node_modules/moment/locale/sv.js'),
  'sw': () => import('../../../../node_modules/moment/locale/sw.js'),
  'ta': () => import('../../../../node_modules/moment/locale/ta.js'),
  'te': () => import('../../../../node_modules/moment/locale/te.js'),
  'tet': () => import('../../../../node_modules/moment/locale/tet.js'),
  'tg': () => import('../../../../node_modules/moment/locale/tg.js'),
  'th': () => import('../../../../node_modules/moment/locale/th.js'),
  'tk': () => import('../../../../node_modules/moment/locale/tk.js'),
  'tl': () => import('../../../../node_modules/moment/locale/tl-ph.js'), // fallback to tl-PH for tl language
  'tl-ph': () => import('../../../../node_modules/moment/locale/tl-ph.js'),
  'tlh': () => import('../../../../node_modules/moment/locale/tlh.js'),
  'tr': () => import('../../../../node_modules/moment/locale/tr.js'),
  'tzl': () => import('../../../../node_modules/moment/locale/tzl.js'),
  'tzm': () => import('../../../../node_modules/moment/locale/tzm.js'),
  'tzm-latn': () => import('../../../../node_modules/moment/locale/tzm-latn.js'),
  'ug-cn': () => import('../../../../node_modules/moment/locale/ug-cn.js'),
  'uk': () => import('../../../../node_modules/moment/locale/uk.js'),
  'ur': () => import('../../../../node_modules/moment/locale/ur.js'),
  'uz': () => import('../../../../node_modules/moment/locale/uz.js'),
  'uz-latn': () => import('../../../../node_modules/moment/locale/uz-latn.js'),
  'vi': () => import('../../../../node_modules/moment/locale/vi.js'),
  'x-pseudo': () => import('../../../../node_modules/moment/locale/x-pseudo.js'),
  'yo': () => import('../../../../node_modules/moment/locale/yo.js'),
  'zh': () => import('../../../../node_modules/moment/locale/zh-cn.js'), // fallback to zh-CN for zh language
  'zh-cn': () => import('../../../../node_modules/moment/locale/zh-cn.js'),
  'zh-hk': () => import('../../../../node_modules/moment/locale/zh-hk.js'),
  'zh-mo': () => import('../../../../node_modules/moment/locale/zh-mo.js'),
  'zh-tw': () => import('../../../../node_modules/moment/locale/zh-tw.js'),
};
